import { render } from "./OrderList.vue?vue&type=template&id=6a399b71"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__